import Service from 'src/setup/network';
import { Dispatch } from 'redux';
import {
  FETCH_FLOOR_FAILURE,
  FETCH_FLOOR_REQUEST,
  FETCH_FLOOR_SUCCESS,
  FloorActionType,
} from '../types/floorType';
import { Floor } from 'src/types/model';

export const fetchFloorRequest = (): FloorActionType => ({
  type: FETCH_FLOOR_REQUEST,
});

export const fetchFloorSuccess = (data: Floor[]): FloorActionType => ({
  type: FETCH_FLOOR_SUCCESS,
  payload: data,
});

export const fetchFloorFailure = (error: string): FloorActionType => ({
  type: FETCH_FLOOR_FAILURE,
  payload: error,
});

export const fetchFloor = () => {
  return async (dispatch: Dispatch<FloorActionType>) => {
    dispatch(fetchFloorRequest());
    try {
      const request = await Service.get('/floors');
      const data: Floor[] = request?.data;
      dispatch(fetchFloorSuccess(data));
    } catch (error: any) {
      dispatch(fetchFloorFailure(error?.response?.data?.message));
      throw new Error('Failed to fetch table');
    }
  };
};
